<template>
  <div>
    <loader v-if="isLoading"></loader>
    <div v-else-if="needPdn" id="pdnConfirmPDL" class="alignPDN">
      <div class="pdnHead">
        <svg width="643" height="117" viewBox="0 0 643 117" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M85.067 30.323c-7.803.39-14.436 4.288-18.728 10.134C62.827 35 57.365 31.103 50.73 29.934v8.574c6.633 1.949 11.316 7.795 11.316 14.81h8.584c.39-6.625 5.072-12.082 11.315-14.03v48.329h8.194V30.323h-5.073z" fill="#3FAE2A"/><path d="M49.938 29.551h-7.412c-11.316 1.949-19.9 11.693-19.9 23.385 0 11.693 8.584 21.437 19.509 23.385v10.913h8.584V76.321c8.584-1.559 15.997-8.184 18.338-16.37h-8.974c-1.95 3.898-5.462 6.627-9.364 7.796V29.94c-.39-.39-.78-.39-.78-.39zm-7.803 38.196c-6.633-1.949-11.315-7.795-11.315-14.81 0-7.016 4.682-12.863 11.315-14.811v29.62z" fill="#00563F"/><path d="M8.194 58.463C8.194 35.078 23.8 15.2 45.26 8.964V0C19.509 6.626 0 30.011 0 58.463s19.509 51.837 45.65 58.463v-8.575C24.192 101.725 8.195 81.848 8.195 58.463zM120.173 58.464c0-28.062-19.509-51.837-45.65-58.463v8.575c21.46 6.236 37.066 26.113 37.066 49.498 0 23.385-15.607 43.263-37.067 49.499v8.574c26.533-6.236 45.651-29.62 45.651-57.683z" fill="#00563F"/><path d="M163.846 83.75c-7.804 0-14.437-2.338-19.509-7.015-5.073-4.677-7.804-10.913-7.804-18.319 0-7.405 2.731-13.641 7.804-18.318 5.072-4.677 11.705-7.016 19.509-7.016h1.17v-5.066l-7.413-1.17V21h24.191v5.846l-7.804 1.17v5.066h1.171c7.803 0 14.436 2.339 19.509 7.016 5.072 4.677 7.803 10.913 7.803 18.318 0 7.406-2.731 13.642-7.803 18.319-5.073 4.677-11.706 7.015-19.509 7.015h-1.171v4.677l7.414 1.17v5.846h-24.191v-5.846l7.413-1.17V83.75h-.78zm0-43.652c-5.853 0-10.145 1.559-13.657 5.067-3.121 3.118-4.682 7.795-4.682 13.251 0 5.457 1.561 10.134 4.682 13.252 3.122 3.118 7.804 5.067 13.657 5.067h1.17V40.098h-1.17zm10.144 0v36.637h1.171c5.853 0 10.145-1.56 13.266-5.067 3.121-3.118 4.682-7.795 4.682-13.252 0-5.456-1.561-10.133-4.682-13.251-3.121-3.118-7.804-5.067-13.266-5.067h-1.171zM234.087 24.513v5.846l-7.413 1.17v38.585h.39l32.385-34.688v-3.508l-7.414-1.169v-6.236h23.801v5.846l-7.413 1.17v53.006l7.413 1.17v5.846h-24.191v-5.847l7.414-1.169V47.12h-.391l-32.384 34.688v3.118l7.413 1.17v5.845h-24.191v-5.846l7.413-1.17V31.919l-7.413-1.169v-6.236H234.087zM282.458 30.36v-5.847h24.191v5.846l-7.414 1.17v23.385h32.775V31.529l-7.413-1.17v-5.846H348.398v5.846l-7.414 1.17v53.006l7.414 1.17v5.846h-24.191v-5.847l7.413-1.169V61.93h-32.775v22.605l7.413 1.17v5.846h-24.191v-5.847l7.414-1.169V31.92l-7.023-1.56z" fill="#3FAE2A"/><path d="M420.974 38.154l-21.85 53.786h-6.243l-21.85-53.785h-.39l.78 27.282v19.488l7.414 1.17v5.845h-24.191v-5.846l7.413-1.17V31.919l-7.413-1.169v-6.236H373.762l21.46 54.566h.39l21.46-54.566h19.119v5.846l-7.414 1.17v53.006l7.414 1.17v5.846H412v-5.847l7.413-1.169V65.048l1.561-26.894zM502.917 58.81c0 9.743-2.731 17.928-8.584 24.164-5.462 6.626-12.876 9.744-21.85 9.744-8.584 0-15.607-3.118-21.07-9.744-5.462-6.626-8.193-14.421-8.193-24.165v-1.17c0-9.743 2.731-17.928 8.193-24.164 5.463-6.236 12.486-9.744 21.07-9.744 8.974 0 16.388 3.118 21.85 9.744 5.463 6.626 8.584 14.421 8.584 24.165v1.17zm-8.974-1.17c0-7.795-1.951-14.031-5.463-19.098-3.511-5.067-8.974-7.405-15.607-7.405-6.243 0-11.315 2.338-14.826 7.405-3.512 5.067-5.463 11.303-5.463 19.098v1.17c0 7.794 1.951 14.42 5.463 19.097 3.511 5.067 8.583 7.405 14.826 7.405 6.633 0 12.096-2.338 15.607-7.405 3.512-5.067 5.463-11.303 5.463-19.098v-1.17zM531.792 31.919l-1.171 24.554c-.78 12.472-2.341 21.826-5.462 27.283-3.122 5.456-8.194 8.184-15.217 8.184h-2.341v-7.015h1.95c4.292 0 7.024-1.949 8.975-6.236 1.56-4.287 2.731-11.693 3.121-22.216l1.171-24.554-7.024-1.17v-6.236h56.186v5.846l-7.804 1.56v53.006l7.414 1.17v5.845h-24.191v-5.846l7.413-1.17V31.919h-23.02zM602.403 31.919l-1.171 24.554c-.78 12.472-2.341 21.826-5.462 27.283-3.121 5.456-8.194 8.184-15.217 8.184h-2.341v-7.015h1.951c4.292 0 7.023-1.949 8.974-6.236 1.561-4.287 2.731-11.693 3.121-22.216l1.171-24.554-7.023-1.17v-6.236h55.795v5.846l-7.413 1.17v53.006l7.413 1.17v5.846H618.01v-5.847l7.413-1.169V31.92h-23.02z" fill="#00563F"/></svg>
        <p>
          Общество с ограниченной ответственностью Микрокредитная компания "Финмолл" (ООО МКК "Финмолл"). РФ, 630112,
          г.Новосибирск, ул. Фрунзе, д.242, пом. 406. ОГРН 1117746509638, ИНН 7705954143, КПП 785250001, р\с
          40701810738000002048, к\с 30101810400000000225, БИК 044525225, ПАО Сбербанк, №9038/01675, 119034, г. Москва, б-р
          Зубовский, 13, 1. www.finmoll.ru Тел.: 8 800 600 99 90
        </p>
      </div>

      <div>
        <div class="title">
          <h3>Уведомление о рассчитанном значении ПДН</h3>
        </div>
        <div>
          <p class="demandNum">Номер заявки {{ dg.extended.DemandId }} </p>

          <p class="textBlock">
            Настоящим Общество с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ» (ОГРН 1117746509638),
            расположенному по адресу: 630112, Новосибирская область, город Новосибирск, улица Фрунзе, дом 242, помещение
            406 (Далее – Общество) уведомляет заемщика:
          </p>


          <div class="table">
            <div class="string">
              <p>Фамилия</p>
              <p>{{ dg.LAST_NAME }}</p>
            </div>
            <div class="string">
              <p>Имя</p>
              <p>{{ dg.FIRST_NAME }}</p>
            </div>
            <div class="string">
              <p>Отчество</p>
              <p>{{ dg.SECOND_NAME }}</p>
            </div>
            <div class="string">
              <p>Паспорт</p>
              <div>
                <div class="passProps">
                  <div class="passProp">
                    <p>Серия</p>
                    <p>{{ dg.PASSPORT_SERIES }}</p>
                  </div>
                  <div class="passProp">
                    <p>Кем выдан</p>
                  </div>
                </div>

                <div class="passProps">

                  <div class="num">
                    <p>Номер</p>
                    <p>{{ dg.PASSPORT_NUMBER }}</p>
                  </div>

                  <div class="date">
                    <p>Дата выдачи</p>
                    <p>{{ dg.PASSPORT_DATE | timeFromXtoDateView }}</p>
                  </div>

                  <div class="issue">
                    <p>{{ dg.PASSPORT_DEP }}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>


          <p class="textBlock">
            о том, что в соответствии с п. 5 ст 5.1. Федерального закона от 21.12.2013 N 353-ФЗ «О потребительском кредите
            (займе)» в порядке установленном Указанием Банка России от 16.10.2023 N 6579-У «О требованиях к порядку
            расчета кредитными организациями или микрофинансовыми организациями суммы величин среднемесячных платежей и
            расчета величины среднемесячного дохода заемщика, в том числе к перечню данных, используемых для расчета
            величины среднемесячного дохода заемщика», Общество рассчитывает показатель долговой нагрузки (далее-ПДН)
            заемщика - физического лица при принятии решения о предоставлении потребительского займа.
          </p>

          <p class="textBlock">
            Заемщик, настоящим подтверждает Обществу факт ознакомления о существующем риске неисполнения им обязательств
            по предоставляемому потребительскому займу, по которому рассчитан показатель долговой нагрузки, превышающий
            пятьдесят процентов, и риске применения к нему за такое неисполнение штрафных санкций.
          </p>

          <p class="textBlock">
            Настоящим информируем, что перед заключением договора потребительского микрозайма заемщик обязан
            проанализировать своё финансовое положение и учесть предполагаемые сроки и суммы поступления денежных средств
            для исполнения своих обязательств по заключаемому договору потребительского микрозайма. Также информируем, что
            заемщик обязан учесть о возможном наступлении обстоятельств непреодолимой силы и иных обстоятельств, которые
            могут привести к невозможности исполнения заемщиком своих обязательств по договору (в том числе, потеря
            работы, задержка получения заработной платы и иных видов доходов по не зависящим от заемщика причинам,
            состояние здоровья заемщика, которое способно негативно повлиять на трудоустройство и, соответственно,
            получение дохода). Настоящим информируем, о возможном увеличении суммы расходов по сравнению с ожидаемой
            суммой расходов, при условии несвоевременном исполнении заемщиком обязательств по договору потребительского
            микрозайма, а также о том, что в отношении заемщика может быть применена неустойка в размере 20 % годовых от
            суммы задолженности по основному долгу за каждый день просрочки исполнения обязательств по оплате
            задолженности, а также иные меры ответственности, предусмотренные законодательством Российской Федерации и
            условиями Договора, такие как досрочное истребование всей суммы займа либо уступка задолженности третьим
            лицам.
          </p>






          <div class="signature">
            <!--            <p>Аналог собственноручной подписи заемщика ____________ проставленная в порядке Соглашения об использовании аналога собственноручной подписи.<br>-->
            <!--              Либо<br>-->
            <!--              ___________________/ _________________<br>-->
            <!--              Дата:-->
            <!--            </p>-->
            <!--            <signature-->
            <!--                :LastName="dg.LAST_NAME"-->
            <!--                :FirstName="dg.FIRST_NAME"-->
            <!--                :MiddleName="dg.SECOND_NAME"-->
            <!--                :DemandDate="dg.DemandDate"-->
            <!--                :DataConfirm="dg.timestampUpdate"-->
            <!--            ></signature>-->
          </div>



          <div class="link">
            <p>____________________________________________</p>
            <p>¹По договорам, заключенным на срок не превышающий 30 дней и в сумме не более 30 000 рублей.</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="alignPDN">
      Документ не требуется
    </div>
  </div>
</template>

<script>
export default {
  name: "confirmPdn",
  components: {
    // signature: () => import('@/components/other/signature'),
    loader: () => import('@/views/pdlloan/uiLoader'),
  },
  data() {
    return {
      isLoading: true,
      needPdn: false,
      dg: {
        extended: {
          DemandId: ''
        }
      }
    }
  },
  methods: {
    pdnChek(iteration = 0) {
      return new Promise((resolve) => {
        this.$external.consoleDebug('baseLoanGetDesign', 'open');
        iteration += 1;
        if (iteration > 180) {
          resolve(true)
        } else {
          setTimeout(() => {

            this.$axios({
              method: 'post',
              url: process.env.VUE_APP_URL_PDN_CHECK,
              data: {
                token: this.$route.params.token,
              }
            }).then((res) => {
              if (res?.data?.result?.Value === null) {
                this.pdnChek(iteration).then((res) => {
                  resolve(res)
                })
              } else {
                if (res?.data?.result && res?.data?.result?.Value === false) {
                  resolve(false);
                } else {
                  resolve(true)
                }
              }
            }).catch(() => {
              resolve(true);
            });

          }, 5000);
        }
      });
    },
    loadIU() {
      this.$axios({
        method: 'post',
        url: process.env.VUE_APP_URL_LOAN,
        data: {
          action: 'getIU',
          token: this.$route.params.token,
          session_id: this.$route.params.session_id
        }
      }).then(res => {
        try {
          if (res.data.result.extended !== undefined) {
            res.data.result.extended = JSON.parse(res.data.result.extended);
          }
        } catch (e) {
          console.log(e)
        }
        this.dg = Object.assign(this.dg, res.data.result)
      }).catch(res => {
        console.log(res)
        alert('Ошибка формирования иу sid=' + this.$route.params.session_id)
      });
    }
  },
  mounted() {
    this.pdnChek().then(res => {
      this.needPdn = res
      if (res) {
        this.loadIU()
      }
    }
    ).finally(() => {this.isLoading = false})
  },
  created() {
    window.addEventListener('focus', this.loadIU)
  }
}
</script>

<style scoped>
p { margin: 0 }
.alignPDN { width: 750px; margin: 0 auto  }
#pdnConfirmPDL .title { text-align: center }
#pdnConfirmPDL .demandNum { text-align: right; margin: 10px 0 20px 0; font-weight: bold }
#pdnConfirmPDL .table { border: 1px solid black; margin-bottom: 20px }
#pdnConfirmPDL .table p { padding: 5px }
#pdnConfirmPDL .table>.string{ border-bottom: 1px solid black; display: flex }
#pdnConfirmPDL .table>.string:last-child{ border-bottom: none; display: flex }
#pdnConfirmPDL .table>.string>p:first-child { border-right: 1px solid black; width: 10% }
#pdnConfirmPDL .table>.string>div { width: 89%; display: flex }
#pdnConfirmPDL .table>.string .passProps {  }
#pdnConfirmPDL .table>.string .passProps:first-child { display: flex; flex-direction: column; width: 20%; border-right: 1px solid black }
#pdnConfirmPDL .table>.string .passProps:last-child { display: flex; flex-wrap: wrap; flex-direction: unset; width: 100%; align-content: flex-start; }
#pdnConfirmPDL .table>.string .passProps>.passProp {  }
#pdnConfirmPDL .table>.string .passProps>.passProp:first-child { border-bottom: 1px solid black; display: flex }
#pdnConfirmPDL .table>.string .passProps>.passProp:first-child>p:first-child { border-right: 1px solid black }
#pdnConfirmPDL .table>.string .passProps>.num { width: 50%; display: flex; border-bottom: 1px solid black }
#pdnConfirmPDL .table>.string .passProps>.num>p { border-right: 1px solid black; width: 50% }
#pdnConfirmPDL .table>.string .passProps>.date { width: 50%; display: flex; border-bottom: 1px solid black }
#pdnConfirmPDL .table>.string .passProps>.date>p { width: 50% }
#pdnConfirmPDL .table>.string .passProps>.date>p:first-child { border-right: 1px solid black }
#pdnConfirmPDL .table>.string .passProps>.issue { width: 100% }
#pdnConfirmPDL .textBlock { margin-bottom: 20px }
#pdnConfirmPDL .checkBoxes { margin-bottom: 20px }
#pdnConfirmPDL .checkBoxes>div { display: flex }
#pdnConfirmPDL .checkBoxes>div>input { margin-right: 8px }
#pdnConfirmPDL .signature { margin-bottom: 50px }
#pdnConfirmPDL .link { margin-bottom: 100px }
#pdnConfirmPDL .pdnHead { display: flex; margin-top: 10px; align-items: center }
#pdnConfirmPDL .pdnHead>svg { width: 40%; padding-right: 40px; border-right: 1px black solid }
#pdnConfirmPDL .pdnHead>p { width: 60%; font-size: 10px; padding-left: 20px; line-height: normal; font-weight: bold }

@media print {
  .alignPDN { width: 750px }
  #pdnConfirmPDL p { font-size: 13px }
  #pdnConfirmPDL .table p { padding: 3px }
  #pdnConfirmPDL .checkBoxes { margin-bottom: 30px }
  #pdnConfirmPDL .signature { margin-bottom: 60px }
  #pdnConfirmPDL .link { margin-bottom: 120px }
  #pdnConfirmPDL .pdnHead>svg { width: 40% }
}

</style>
